var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { Button, TextInput } from "..";
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  display: grid;\n  grid-template-colums: 1fr;\n  grid-gap: 1rem;\n"], ["\n  height: 100%;\n  width: 100%;\n  display: grid;\n  grid-template-colums: 1fr;\n  grid-gap: 1rem;\n"])));
var Section = function () {
    var _a = useState([]), files = _a[0], setFiles = _a[1];
    var handleChangeFile = useCallback(function (filesNew) {
        setFiles(files.concat(filesNew));
    }, [files]);
    useEffect(function () {
        console.log({ files: files });
    }, [files]);
    return (React.createElement(Form, null,
        React.createElement(TextInput, { value: "", placeholder: "name", label: "Name", helpText: "The name you would like to be referred to as", required: true }),
        React.createElement(TextInput, { value: "", placeholder: "email", label: "Email", helpText: "An email we can contact you at", required: true }),
        React.createElement(FileUpload, { id: "fileupload", onChange: handleChangeFile })));
};
var FileInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid ".concat(theme.borderInput(), ";\n    background-color: ").concat(theme.bgInput(), ";\n    border-radius: 5px;\n    cursor: pointer;\n  ");
});
var FileUpload = function (_a) {
    var id = _a.id, onChange = _a.onChange;
    var _b = useState([]), files = _b[0], setFiles = _b[1];
    var handleClick = useCallback(function () {
        var _a;
        (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.click();
    }, [id]);
    var handleDrop = useCallback(function (e) {
        e.preventDefault();
        var filesNew = [];
        if (e.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (e.dataTransfer.items[i].kind === "file") {
                    var file = e.dataTransfer.items[i].getAsFile();
                    if (file) {
                        console.log("… file[" + i + "].name = " + file.name);
                        filesNew.push(file);
                    }
                    else {
                        console.log("file came back null");
                    }
                }
                else {
                    console.log("items on the cursor are not files");
                }
            }
        }
        else {
            // Use DataTransfer interface to access the file(s)
            console.log({ files: e.dataTransfer.files });
            filesNew = Array.from(e.dataTransfer.files);
        }
        if (filesNew.length > 0) {
            setFiles(files.concat(filesNew));
            onChange(filesNew);
        }
    }, [files, onChange]);
    var handleDragOver = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    var handleAttachFile = useCallback(function (e) {
        if (e.target.files) {
            setFiles(files.concat(Array.from(e.target.files)));
        }
        if (e.target.files) {
            onChange(Array.from(e.target.files));
        }
    }, [files, onChange]);
    return (React.createElement(Wrapper, { onClick: handleClick, onDrop: handleDrop, onDragOver: handleDragOver },
        React.createElement(Button, { type: "button", emphasis: "grey", variant: "text" }, "Attach File(s)"),
        React.createElement(FileInput, { type: "file", id: id, value: "", onChange: handleAttachFile, multiple: true })));
};
export default Section;
var templateObject_1, templateObject_2, templateObject_3;
